module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-2800.bcdaa174.svg";